import {
  actionTypes as sharedActionTypes,
  sessionReducer,
  snackbarMessageReducer,
  userReducer,
  selectOptions,
} from 'entoro-shared';
import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import actionTypes from './actionTypes';
import { apolloClient } from '../apollo';

const initialcrowdfundingOptionState = {
  crowdfundingInvestor: selectOptions.map.NO,
};

const crowdfundingInvestorReducer = (
  state = initialcrowdfundingOptionState,
  action
) => {
  switch (action.type) {
    case actionTypes.SET_CROWDFUNDING_INVESTOR:
      return {
        ...state,
        crowdfundingInvestor: action.payload,
      };
    default:
      return state;
  }
};

const crowdfundModalReducer = (state = false, action) => {
  switch (action.type) {
    case actionTypes.SET_CROWDFUNDING_MODAL:
      return {
        ...state,
        crowdfundModal: action.payload,
      };
    default:
      return state;
  }
};

const tenantReducer = (state = null, action) => {
  switch (action.type) {
    case actionTypes.SET_CURRENT_TENANT:
      return {
        ...state,
        ...action.currentTenant,
      };
    default:
      return state;
  }
};

const appReducer = combineReducers({
  apollo: apolloClient.reducer(),
  form: reduxFormReducer,
  investorUser: userReducer,
  session: sessionReducer,
  snackbarMessage: snackbarMessageReducer,
  router: routerReducer,
  tenant: tenantReducer,
  crowdfunding: crowdfundingInvestorReducer,
  crowdfundModal: crowdfundModalReducer,
});

const rootReducer = (state, action) => {
  const nextState =
    action.type === sharedActionTypes.LOGOUT
      ? { tenant: state && state.tenant } // Reset all state except tenant
      : state;

  return appReducer(nextState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers.js